import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    Paper,
    Avatar,
    LinearProgress,
    Chip,
    Divider,
    Tooltip,
    Grid,
    Badge
} from '@mui/material';
import {
    CloudUpload as CloudUploadIcon,
    Download as DownloadIcon,
    Image as ImageIcon,
    Description as DescriptionIcon,
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
    Delete as DeleteIcon,
    Close as CloseIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    borderRadius: '16px',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.05)',
    background: 'white',
}));

const StyledUploadButton = styled(Button)(({ theme }) => ({
    padding: '10px 20px',
    textTransform: 'none',
    borderRadius: '8px',
    border: `2px dashed ${theme.palette.primary.light}`,
    '&:hover': {
        border: `2px dashed ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.light + '20',
    },
}));

const FilePreviewContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    borderRadius: '8px',
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[200]}`,
    position: 'relative',
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
    },
}));

const RemoveFileButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 4,
    top: 4,
    padding: '4px',
    backgroundColor: theme.palette.grey[300],
    '&:hover': {
        backgroundColor: theme.palette.grey[400],
    },
}));

const ConferenceOrgSpeakerFiles = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [title, setTitle] = useState('');
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(null); // 'success' or 'error'
    const [selectedFilesCount, setSelectedFilesCount] = useState(0);
    const [downloading, setDownloading] = useState(false);

    const fetchFiles = async () => {
        try {
            const res = await axios.get('/api/org-get-speaker-docs', {
                params: { eventid: localStorage.getItem('eventid') }
            });

            if (res.data.status === 200) {
                setUploadedFiles(res.data.documents);
            }
        } catch (err) {
            console.error('Failed to fetch uploaded files', err);
        }
    };


    useEffect(() => {
        fetchFiles();
    }, []);


    const isImage = (filename) => /\.(jpg|jpeg|png|gif|webp)$/i.test(filename);
    const getFileType = (filename) => {
        if (isImage(filename)) return 'image';
        if (/\.(pdf)$/i.test(filename)) return 'pdf';
        if (/\.(docx?)$/i.test(filename)) return 'word';
        if (/\.(xlsx?)$/i.test(filename)) return 'excel';
        if (/\.(pptx?)$/i.test(filename)) return 'powerpoint';
        return 'file';
    };

    const getFileIcon = (filename) => {
        const type = getFileType(filename);
        switch (type) {
            case 'image': return <ImageIcon color="primary" />;
            case 'pdf': return <DescriptionIcon color="error" />;
            case 'word': return <DescriptionIcon color="info" />;
            case 'excel': return <DescriptionIcon color="success" />;
            case 'powerpoint': return <DescriptionIcon color="warning" />;
            default: return <DescriptionIcon />;
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    // Simplest possible implementation
    const handleDownload = async (url, filename) => {
        try {
            setDownloading(true);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error('Download error:', err);
        } finally {
            setDownloading(false);
        }
    };

    const staticChange = eventid == 68;

    return (
        <Box sx={{
            width: '100%', maxWidth: '900px',
            mx: 'auto',
            pt: 20,
            px: 3
        }}>
            <Box sx={{ width: '100%', maxWidth: '900px' }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 3, color: 'text.primary' }}>
                {staticChange ? "Hospital Documents" : "Speaker Documents"}  
                </Typography>
                <Button sx={{
                    float: 'right',
                    marginTop: '2%',
                    ":hover": {
                        color: "white"
                    }
                }}
                    color='success'
                    size='small'
                    variant='contained'
                    onClick={() => { history.goBack() }}>
                    Back
                </Button>



                <StyledPaper elevation={0} sx={{ mt: 4 }}>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 500, mb: 2 }}>
                        Requried Application Froms
                    </Typography>

                    {uploadedFiles.length > 0 ? (
                        <List sx={{ width: '100%' }}>
                            {/* {uploadedFiles.map((doc) => ( */}
                            {uploadedFiles
                                .filter(doc => doc.title && doc.uploaded_file)  // filter here
                                .map((doc) => (
                                    <React.Fragment key={doc.id}>
                                        <ListItem
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                p: 2,
                                                '&:hover': {
                                                    backgroundColor: 'action.hover',
                                                    borderRadius: '8px',
                                                },
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <ListItemIcon>
                                                    {getFileIcon(doc.uploaded_file)}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                            {doc.title}
                                                        </Typography>
                                                    }
                                                    secondary={
                                                        <Typography variant="caption" color="text.secondary">
                                                            Uploaded on {new Date(doc.created_at).toLocaleDateString()}
                                                        </Typography>
                                                    }
                                                />
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {/* <IconButton
                                                <Tooltip title="Download">
                                                        href={doc.uploaded_file_url}
                                                        download
                                                        target="_blank"
                                                        sx={{ color: 'primary.main' }}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                </Tooltip> */}
                                                {/* <Tooltip title="Download">
                                                    <IconButton
                                                        onClick={() => handleDownload(doc.uploaded_file_url, doc.uploaded_file)}
                                                        sx={{ color: 'primary.main' }}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                </Tooltip> */}
                                                <Tooltip title="Download">
                                                    <IconButton
                                                        onClick={() => handleDownload(
                                                            doc.uploaded_file_url,
                                                            `${doc.title}.${doc.uploaded_file.split('.').pop()}`
                                                        )}
                                                        disabled={downloading}
                                                    >
                                                        {downloading ? (
                                                            <CircularProgress size={24} />
                                                        ) : (
                                                            <DownloadIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>

                                            </Box>
                                        </ListItem>

                                        {isImage(doc.uploaded_file) && (
                                            <Box
                                                component="img"
                                                src={doc.uploaded_file_url}
                                                alt={doc.title}
                                                sx={{
                                                    maxWidth: '300px',
                                                    maxHeight: '300px',
                                                    mt: 1,
                                                    mb: 2,
                                                    ml: 8,
                                                    borderRadius: '8px',
                                                    boxShadow: 1
                                                }}
                                            />
                                        )}

                                        <Divider sx={{ my: 1 }} />
                                    </React.Fragment>
                                ))}
                        </List>
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                py: 4,
                                color: 'text.secondary',
                            }}
                        >
                            <DescriptionIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                            <Typography>No documents uploaded yet</Typography>
                            <Typography variant="caption">Upload your first documents above</Typography>
                        </Box>
                    )}
                </StyledPaper>
            </Box>
        </Box>
    );
};



export default ConferenceOrgSpeakerFiles;
